<script lang="ts">
import { defineComponent, PropType } from 'vue'
import VueScrollTo from 'vue-scrollto'
import LogoBizHint from '@/components/logo/LogoBizHintDefault.vue'
import ButtonLpCta from '@/components/button/ButtonLpCta.vue'
import { useUserStore } from '@/stores/user'
import { newUserRegistrationPath } from '@/generated/railsRoutes'

export default defineComponent({
  name: 'AboutHeader',

  components: {
    LogoBizHint,
    ButtonLpCta,
  },

  props: {
    sections: {
      type: Array as PropType<string[]>,
      default: () => [],
    },

    trackingCodePrefix: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    // store
    const userStore = useUserStore()

    const LOCAL_NAVIGATION = [
      {
        id: 'about-01',
        label: 'BizHintとは',
      },
      {
        id: 'about-03',
        label: 'BizHintでできること',
      },
      {
        id: 'about-04',
        label: '利用者の声',
      },
    ] as const

    const scrollTo = (id: string) => {
      if (!props.sections.includes(id)) return
      VueScrollTo.scrollTo(`#${id}`)
    }

    return {
      // constants
      LOCAL_NAVIGATION,

      // routes
      newUserRegistrationPath,

      // store
      userStore,

      // methods
      scrollTo,
    }
  },
})
</script>

<template>
  <header
    ref="header"
    class="f-header">
    <div class="f-header--body">
      <div class="l-cols__header">
        <div class="l-cols__header--col is-logo">
          <LogoBizHint
            :additional-style-class="['is-header']"
            type="gray" />
        <!-- /.l-cols__header col --></div>

        <div class="l-cols__header--col is-navigation">
          <div class="o-list__localNavigation">
            <ul class="o-list__localNavigation--items">
              <li
                v-for="item in LOCAL_NAVIGATION"
                :key="item.id"
                class="o-list__localNavigation--item">
                <div class="o-action__localNavigation">
                  <button
                    class="o-action__localNavigation--item"
                    @click="scrollTo(item.id)">
                    {{ item.label }}
                  </button>
                <!-- /.o-action__localNavigation --></div>
              </li>
            </ul>
          <!-- /.o-list__localNavigation --></div>
        <!-- /.l-cols__header col --></div>

        <template v-if="!userStore.context.isSignedIn">
          <!-- 会員登録 -->
          <div class="l-cols__header--col is-signUp">
            <ButtonLpCta
              :href="newUserRegistrationPath({ trcd: `${trackingCodePrefix}_header` })"
              font-size="small"
              size="small">
              新規登録
            </ButtonLpCta>
          <!-- /.l-cols__header col --></div>
        </template>
      <!-- /.l-cols__header --></div>
    <!-- /.f-header body --></div>
  </header>
</template>

<style lang="sass" scoped>
$header-width-pc: 1240
$header-height-pc: 60
$header-height-sp: 42
// Foundation
.f-header
  $root: &
  width: 100%
  position: fixed
  top: 0
  left: 0
  padding: 0 #{$global-prop-pc}px
  background-color: rgba($bg-white, 1)
  box-shadow: 0 0 10px 4px rgba($bg-black, 0.1)
  z-index: 5

  & &--body
    width: 100%
    max-width: #{$header-width-pc}px
    height: #{$header-height-pc}px
    margin: 0 auto

  +breakpoint($max-media: tablet)
    padding: 0

    #{$root}--body
      height: #{$header-height-sp}px
      padding: 0 #{$global-prop-sp}px

// Layout
.l-cols__header
  $root: &
  height: 100%
  display: flex
  align-items: center

  & &--col
    &.is-logo
      width: 100%
      max-width: 150px
      line-height: 1

    &.is-navigation
      flex-grow: 1
      margin-left: 2em

    &.is-signUp
      margin-left: 1.5em

  +breakpoint($max-media: tablet)
    #{$root}--col
      &.is-navigation
        display: none

      &.is-signUp
        display: none

// object
.o-list__localNavigation
  & &--items
    display: flex
    align-items: center
    justify-content: flex-end

  & &--item
    margin-left: 2em

    &:first-child
      margin-left: 0

.o-action__localNavigation
  & &--item
    color: $font-black
    font:
      size: $font-small
      weight: bold

    &:hover
      color: $font-orange
</style>
